import clsx from 'clsx'
import { CSSProperties } from 'react'

export interface TooltipType {
  content: string | Array<string>
  toggle: boolean
  type?: 'warning' | 'bottom' | ''
  style?: CSSProperties
  className?: string
}

export const Tooltip = ({
  content,
  toggle,
  type,
  style: propsStyle,
  className,
}: TooltipType): JSX.Element => {
  return (
    <>
      {toggle && (
        <div
          className={clsx('sys-tooltip', className || '', {
            'sys-tooltip-warning': type === 'warning',
            'sys-tooltip-bootom': type === 'bottom',
          })}
        >
          <div className="sys-tooltip-content top">
            {Array.isArray(content)
              ? content.map((s, i) => (
                  <p
                    key={i}
                    style={{
                      margin: 0,
                      verticalAlign: 'middle',
                      ...propsStyle,
                    }}
                  >
                    {s}
                  </p>
                ))
              : content}
          </div>
        </div>
      )}
    </>
  )
}
